import { rfqConfirmationProductListStyles } from "@pace/Overrides/Widgets/RfqConfirmation/RfqConfirmationProductList";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

rfqConfirmationProductListStyles.cartLinesHeaderStyle = {
    wrapper: {
        css: css`
            grid-template-columns: 91px minmax(0, 600px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(
                    0,
                    135px
                );
        `,
    },
    availability: {
        css: css`
            display: none;
        `,
    },
    itemDescription: {
        css: css`
            grid-column: 1 / 4;
        `,
    },
    priceUnit: {
        css: css`
            grid-column: 4 / 5;
        `,
    },
    qty: {
        css: css`
            grid-column: 5 / 6;
        `,
    },
    total: {
        css: css`
            grid-column: 6 / 7;
            border-right: none;
        `,
    },
};
rfqConfirmationProductListStyles.cartLinesList = {
    cardExpanded: {
        cartLineContainer: {
            container: {
                css: css`
                    display: grid;
                    grid-template-columns: 91px minmax(0, 600px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(
                            0,
                            135px
                        );
                `,
            },
            availability: {
                css: css`
                    display: none;
                `,
            },
            description: {
                css: css`
                    grid-column: 2 / 4;
                `,
            },
            qty: {
                css: css`
                    padding-top: 6px;
                `,
            },
            price: {
                css: css`
                    ${xScreen("lte", "md")} {
                        grid-column: 1/ 4;
                    }
                `,
            },
            remove: {
                css: css`
                    display: none;
                `,
            },
        },
    },
};
